import React from 'react'

const PagesFooter = () => {
    return (
        <div className='HomeFooterContainer'>
            <p>© 2025 - 2026 Hikmetin İzinde. Built with ÖNDER. All rights reserved.</p>
        </div>
      )
}

export default PagesFooter